module.exports = __webpack_public_path__ + "img/list_outlined_32-1.e3e4d807.svg";